import {
    useEffect,
    useMemo,
    useState,
} from 'react'
import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'
import requests, {
    deploymentSelectionConfig,
} from 'app/requests/Deployment/Deployment.requests'
import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import {
    WithId,
} from 'app/types/common.types'

import ChipSelect from '../ChipSelect'

type DeploymentValue = {
    id?: number,
    value: number,
    label: string | JSX.Element,
}

type Props = {
    title?: string,
    disabled?: boolean,
    required?: boolean,
    value?: WithId<number>[],
    onChange: (value: DeploymentValue[]) => void,
}

const EMPTY_ARRAY = []

const MultipleDeploymentSelector = ({
    title,
    disabled = false,
    required = false,
    onChange,
    value = EMPTY_ARRAY,
}: Readonly<Props>) => {
    const [
        deployments,
        setDeployments,
    ] = useState<DeploymentValue[]>(null)

    const loadOptions = useDelayedLoadOptions(deploymentSelectionConfig)

    const deploymentIds = useMemo(() => {
        if (deployments !== null) return []

        return value.map(({
            id,
        }) => {
            return id
        })
    }, [
        value,
        deployments,
    ])

    const {
        data,
        isDataReady,
    } = useRequest({
        key: RequestKeys.getDeploymentsByIds,
        params: {
            includeFilters: {
                id: deploymentIds,
            },
        },
        requestFunc: RequestFn.getEntity(requests.filterRequest, (promise) => {
            return promise.then((resp) => {
                return (resp?.data as any)?.items
            })
        }),
        keepPreviousData: true,
        enabled: Boolean(deploymentIds.length),
    })

    useEffect(() => {
        if (isDataReady) {
            setDeployments(data.length ? deploymentSelectionConfig.convertion(data) : [])
        }
    }, [
        data,
        isDataReady,
    ])

    const onChangeValue = (newValue: DeploymentValue[]) => {
        onChange(newValue)
        setDeployments(newValue)
    }

    return (
        <ChipSelect
            title={title}
            value={deployments ?? []}
            onChange={onChangeValue}
            loadOptions={loadOptions}
            disabled={disabled}
            required={required}
            showTitleOptions
            menuShouldBlockScroll
            menuPortalTarget={document.body}
        />
    )
}

export default MultipleDeploymentSelector
